import { render, staticRenderFns } from "./EditSectionIdVoucher.vue?vue&type=template&id=70c90f24&scoped=true&"
import script from "./EditSectionIdVoucher.vue?vue&type=script&lang=js&"
export * from "./EditSectionIdVoucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c90f24",
  null
  
)

export default component.exports